import styled from "styled-components"

export const PopupContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  min-width: 573px;
  max-width: 60%;
  max-height: 70%;
  top: 200px;
  right: 50%;
  transform: translateX(50%);
  z-index: 1;
  background: rgba(11, 10, 13, 0.8);
  border-radius: 6px;
  overflow: hidden;
  display: none;
  @media only screen and (min-width: 768px) {
    display: block;
  }
  @media only screen and (min-width: 1024px) {
    top: 0px;
  }
`
export const PopupHeader = styled.div`
  background: rgba(28, 30, 36, 0.6);
  box-shadow: inset 0px -1.00948px 0px #292933;
  border-radius: 6px 6px 0px 0px;
  padding: 0 0 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  svg {
    cursor: pointer;
  }
`

export const HeaderTitle = styled.div`
  font-size: 18px;
  text-transform: uppercase;
  line-height: 1;
  padding: 8px 0 6px;
  color: #868b9e;
`

export const PopupContent = styled.div`
  padding: 20px;
  height: 100%;
`
export const CloseDiv = styled.div`
  position: absolute;
  right: 0;
  padding: 0 20px;
  height: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
`
